/**
 * Xtram logo assets — pick by surface.
 * Brand mins: wordmark 120×32px; below that use mark only.
 */

import wordmarkColorSvg from './logos/wordmark-color.svg';
import wordmarkOnBlueSvg from './logos/wordmark-on-blue.svg';
import wordmarkColorPng from './logos/wordmark-color.png';
import wordmarkColorLightBg from './logos/wordmark-color-light-bg.png';
import wordmarkColorDarkBg from './logos/wordmark-color-dark-bg.png';
import wordmarkColorAlt from './logos/wordmark-color-alt.png';
import wordmarkWhiteOnBlue from './logos/wordmark-white-on-blue.png';
import wordmarkWhiteOnDark from './logos/wordmark-white-on-dark.png';

import markColorSvg from './icons/mark-color.svg';
import markWhiteOnBlueSvg from './icons/mark-white-on-blue.svg';
import markColorPng from './icons/mark-color.png';
import markColor2x from './icons/mark-color-2x.png';
import markWhiteOnBluePng from './icons/mark-white-on-blue.png';
import markWhiteOnBlue2x from './icons/mark-white-on-blue-2x.png';
import markColorTransparent from './icons/mark-color-transparent.png';
import markWhiteOnBlueSquare from './icons/mark-white-on-blue-square.png';

export const XTRAM_LOGOS = {
  wordmarkColor: wordmarkColorSvg,
  wordmarkColorPng,
  wordmarkColorLightBg,
  wordmarkColorAlt,
  wordmarkColorDarkBg,
  wordmarkOnBlue: wordmarkOnBlueSvg,
  wordmarkWhiteOnBlue,
  wordmarkWhiteOnDark,
  markColor: markColorSvg,
  markColorPng,
  markColor2x,
  markColorTransparent,
  markWhiteOnBlue: markWhiteOnBlueSvg,
  markWhiteOnBluePng,
  markWhiteOnBlue2x,
  markWhiteOnBlueSquare,
};

/**
 * @param {'light'|'dark'|'blue'|'photo'|'icon'|'iconBlue'} surface
 */
export function getXtramLogo(surface = 'light') {
  switch (surface) {
    case 'dark':
    case 'photo':
      return XTRAM_LOGOS.wordmarkWhiteOnDark || XTRAM_LOGOS.wordmarkOnBlue;
    case 'blue':
      return XTRAM_LOGOS.wordmarkOnBlue;
    case 'icon':
      return XTRAM_LOGOS.markColor;
    case 'iconBlue':
      return XTRAM_LOGOS.markWhiteOnBlue;
    case 'light':
    default:
      return XTRAM_LOGOS.wordmarkColor;
  }
}

export default XTRAM_LOGOS;
